import { useCallback } from 'react';
import { CANCELLED_BY_USER, useModal } from 'src/shared/modalProvider';
import { LoginFeatureResult, LoginModalOwnProps } from './types';
import { LOGIN_MODAL_NAME } from './const';

export const useLoginModalProvider = (): ((props: LoginModalOwnProps) => Promise<LoginFeatureResult>) => {
  const { openModal, closeModal } = useModal();
  return useCallback(
    (props: LoginModalOwnProps) =>
      new Promise((resolve, reject) => {
        openModal(LOGIN_MODAL_NAME, {
          ...props,
          onFailure: reject,
          onCancel: () => reject(CANCELLED_BY_USER),
          onModalDestroy: () => reject(CANCELLED_BY_USER),
          onSuccess: (result) => {
            resolve(result);
            closeModal();
          },
        });
      }),
    [openModal, closeModal],
  );
};
